import { Routes } from '@angular/router';
import { AuthGuard } from './auth-guard/auth.guard';

// Note: AuthGuard internally checks msalEnable from config.json at runtime
// and allows access when MSAL is disabled
export const routes: Routes = [
    {
        path: '', pathMatch: 'full', redirectTo: 'dashboard',
    },
    {
        path: 'dashboard',
        loadComponent: () => import('./dashboard/download-results/download-results').then(m => m.DownloadResults),
        canActivate: [AuthGuard],
    },
    {
        path: 'unauthorized',
        loadComponent: () => import('./dashboard/unauthorized/unauthorized').then(m => m.Unauthorized),
    },
    {
        path: '**', redirectTo: 'dashboard',
    }
];